import { Stack, Typography } from "@mui/material";
import { InvoiceQRCode } from "Components/Invoices/InvoiceQRCode";
import type { QRCodeVariant } from "Components/Shared/QRCode";
import { Trans } from "react-i18next";
import {
  Resources,
  useResource,
  getResourcePath,
} from "Translations/Resources";
import { TransactionStatus } from "Infrastructure/Api/Api";
import { InfoBox } from "Components/Shared/InfoBox/InfoBox";

const RESOURCES = Resources.Merchant.InitiateDetail;

type Props = {
  paymentDescriptor: string;
  size?: number;
  qrVariant?: QRCodeVariant;
  transactionStatus?: TransactionStatus;
};

export const TransactionQRCode = ({
  paymentDescriptor,
  size = 180,
  qrVariant,
  transactionStatus,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={2} maxWidth="48ch">
      {transactionStatus === TransactionStatus.Success ? (
        <Typography
          variant="h6"
          fontWeight={500}
          fontSize={18}
          textAlign="center"
        >
          <Trans
            i18nKey={getResourcePath(RESOURCES.QRCodeInstructionsSuccess)}
            components={{ newline: <br /> }}
          />
        </Typography>
      ) : (
        <InfoBox variant="warning" content={t(RESOURCES.QRCodeWarning)} />
      )}
      {paymentDescriptor && (
        <InvoiceQRCode
          paymentDescriptor={paymentDescriptor}
          size={size}
          qrVariant={qrVariant}
        />
      )}
    </Stack>
  );
};
